import { Button, Flex, Form, Input } from "antd";
import { ChevronLeft, ShieldCheck } from "lucide-react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthStep } from "../../../pages/Onboarding/Onboarding";
import useSendMfaOtp from "../lib/hooks/useSendMfaOtp";
import useVerifyMfaOtp from "../lib/hooks/useVerifyMfaOtp";
import styles from "../ui/styles.module.scss";
import { useGetMe } from "../lib/hooks/useGetMe";
import { ToastService } from "@shared/lib/services";

interface TwoFactorFormProps {
  navigateTo: (step: AuthStep) => void;
}

export const TwoFactorForm: React.FC<TwoFactorFormProps> = ({ navigateTo }) => {
  const { userDetails } = useGetMe();
  const { otpData, isOtpFetched, otpError, refetchOtp } = useSendMfaOtp();
  const { verifyMfaOtp, isVerifyingOtp, isOtpVerified, verifyOtpError } =
    useVerifyMfaOtp();
  const navigate = useNavigate();

  useEffect(() => {
    if (otpError) {
      ToastService.error(otpError?.message);
    }
  }, [otpError]);

  useEffect(() => {
    if (isOtpFetched) {
      ToastService.success("OTP sent successfully");
    }
  }, [isOtpFetched]);
  useEffect(() => {
    if (isOtpVerified) {
      ToastService.success("OTP verified successfully");
      navigate("/");
    }
  }, [isOtpVerified]);

  return (
    <div className={styles.fadeIn}>
      <div className={styles.iconContainer}>
        <ShieldCheck size={24} />
      </div>
      <h2 className={styles.subTitle}>Check your phone</h2>
      <p className={styles.description}>
        We sent a verification code to your phone ending in{" "}
        <span className={styles.emailHighlight}>
          ••{userDetails?.userEntity?.phoneNumber?.slice(-2)}
        </span>
        .
      </p>

      <Form
        onFinish={(values) => {
          if (values.otp && otpData?.data?.mfaCode) {
            verifyMfaOtp({
              otp: values.otp,
              mfaCode: otpData?.data?.mfaCode || "",
            });
          }
        }}
        size="large"
      >
        <Form.Item
          name="otp"
          rules={[
            { required: true, message: "Please enter code" },
            {
              validator: (_, value) => {
                if (value?.length < 6) {
                  return Promise.reject("OTP must be 6 digits");
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input.OTP
            length={6}
            formatter={(value) => value.replace(/\D/g, "")}
            // className={styles.otpInput}
            size="large"
            id={styles.otpInput}
          />
        </Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          block
          size="large"
          loading={isVerifyingOtp}
        >
          Verify identity
        </Button>
      </Form>

      <div className={styles.otpActions}>
        <a
          className={styles.forgotLink}
          onClick={() => refetchOtp()}
          // disabled={resendTimer > 0}
          // className={
          //   resendTimer > 0 ? styles.resendButtonDisabled : styles.resendButton
          // }
        >
          {/* {resendTimer > 0 ? `Resend code in ${resendTimer}s` : "Resend code"} */}
          Resend Code
        </a>
        <a className={styles.forgotLink} onClick={() => navigateTo("LOGIN")}>
          <Flex gap={5} align="center">
            <ChevronLeft size={16} />
            Back to sign in
          </Flex>
        </a>
      </div>
    </div>
  );
};
